<template>
    <tr class="tableTr">
        <td class="" :class="{'tdGreen': checkClasses['filter_created_date']}">{{ item['created_date'] }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_created_by']}">{{ item.created_by }}</td>
        <td class=""><span class="notes">{{ item.notes }}</span></td>
        <td width="90">
            <div class="btnGroups">
                <button :disabled="getPermissionAction" type="button" @click="onEdit">
                    <svg-sprite icon-id="edit" width="18" height="18"></svg-sprite>
                </button>
                <button :disabled="getPermissionAction" type="button" @click="onRemove">
                    <svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
	name: "TableTr",
	props: {
		item: Object,
		checkClasses: Object,
		getPermissionAction: Boolean
	},
	methods: {
		onEdit() {
			this.$emit('updateEdit', this.item);
		},
		onRemove() {
			this.$emit('updateRemoveItem', this.item.id);
		},
	}
};
</script>
